// extracted by mini-css-extract-plugin
module.exports = {"blog":"BlogGrid_blog__2l7H7","thumb":"BlogGrid_thumb__MaJGK","content":"BlogGrid_content__2rA6N","readmoreBtn":"BlogGrid_readmoreBtn__W8r_o"};